/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    color: '#000000',
    fontName: 'StagSans',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 1.33333333333
  }
}
export default theme
